<template>
    <div class="page-menu g3">
        <ul>
            <li class="head">Simulation</li>
            <li><router-link :to="createLink('demand')">Demand</router-link></li>
            <li><router-link :to="createLink('materials')">Materials</router-link></li>
            <li v-if="$store.state.dataView.forecast.typeName === 'Study'"><router-link :to="createLink('distribution')">Distribution</router-link></li>

            <li v-if="$store.state.dataView.forecast.typeName === 'Study'"><router-link :to="createLink('events')">Events</router-link></li>
            <li v-if="!$store.state.member.isAnonymous"><router-link :to="createLink('share')">Share</router-link></li>
        </ul>
    </div>
</template>


<script>
    export default {
        methods: {
            createLink(link) {
                return '/view/' + this.$route.params.id + '/' + link;
            },
            isSuperAdmin() {
                return this.$store.state.member.isSuperAdmin;
            }
        }
    }
</script>